import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.string,
  type: PropTypes.number,
  logo: PropTypes.string,
  name: PropTypes.string
});



// WEBPACK FOOTER //
// ./src/model/Types/channel.js